import { getOfferInsight } from '../../services/attendantGoalOfferApi';
import { InsightContent, InsightDecisions, InsightKind, InsightStatus } from '../../models/attendantGoalOffer';
import { useInsightPolling } from '../AttendantGoalAiInsight';

interface InsightState { content: InsightContent | null; decisions: InsightDecisions | null; loading: boolean }

/**
 * Leitura da IA do convite. Qualquer coisa diferente de `ready` (unavailable, insufficient_data, erro de rede,
 * timeout do polling) devolve `content: null`: quem usa mostra o texto fixo e os botões seguem funcionando.
 * `refreshKey` refaz a busca (ex.: `suggestionVersion` mudou depois de um `stale_suggestion`).
 */
export const useOfferInsight = (
  offerId: string | undefined,
  kind: InsightKind | undefined,
  refreshKey?: string | number,
): InsightState => {
  const { loading, data } = useInsightPolling(
    (locale) => getOfferInsight(offerId as string, kind as InsightKind, locale),
    (res) => res,
    `${offerId}|${kind}|${refreshKey}`,
    Boolean(offerId && kind),
  );
  const ready = data?.status === InsightStatus.ready && data.content;
  return { content: ready ? data!.content! : null, decisions: ready ? data!.decisions ?? null : null, loading };
};
